export const ShouldDisableAnimations = () => {
    return (
        !window['RequiresAnimationsForTestAutomation'] &&
        Boolean(window['Cypress'])
    );
};
